
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 20 16"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"fill":"currentColor","d":"M19.7128 14.6594l-3.2325-2.5336c.9796-.9981 1.8044-2.21271 2.4113-3.59377C18.9512 8.39363 19 8.15491 19 8c0-.15553-.0488-.39369-.1084-.53209C17.1962 3.61016 13.8418 1 9.99997 1c-1.95838 0-3.78369.68956-5.333 1.86681L1.21294.159656C1.07522.05225.912154 0 .750998 0 .528342 0 .307655.098625.160186.287125c-.255844.326156-.199219.797785.126968 1.053155L18.787 15.8401c.3282.2563.7988.1977 1.0527-.1274.2559-.3262.1993-.7979-.1269-1.0533zm-7.388-5.79049L9.77315 6.86897c.1321-.26509.22682-.55178.22682-.86897 0-.17125-.02735-.33509-.06822-.49309.02319-.00069.04484-.00691.06822-.00691C11.3785 5.5 12.5 6.62153 12.5 8.00172c0 .30797-.0726.59478-.1752.86719zm1.2129.95062C13.8246 9.27388 14 8.66212 14 8.00172V8c0-2.20788-1.7917-4-4.00003-4-1.00647 0-1.916.38037-2.61469.99738L5.88481 3.82141C7.12547 2.96978 8.53518 2.5 9.99997 2.5c3.10873 0 5.97383 2.10931 7.48673 5.49981-.5644 1.26203-1.3253 2.32609-2.2065 3.18549l-1.7425-1.36577zM10.0017 12c.4194 0 .8157-.0826 1.1955-.2024l-1.73367-1.3588c-.74309-.1635-1.3556-.66114-1.68931-1.32411L6.02578 7.74431c-.00553.08619-.02581.1681-.02581.25569 0 2.2079 1.79168 4 4 4h.00173zm-.00173 1.5c-3.10869 0-5.97388-2.1093-7.48675-5.49988.33856-.75703.75287-1.4384 1.21297-2.05815L2.5399 5.01222c-.55525.74194-1.03956 1.56359-1.43153 2.45569-.05956.1384-.108403.37712-.108403.53209 0 .15553.048843.39363.108403.53203C2.80369 12.3898 6.15819 15 9.99997 15c1.42063 0 2.77383-.3591 4.00203-1.0042l-1.3394-1.0497c-.8492.3487-1.742.5539-2.66263.5539z"}})])
          )
        }
      }
    